export default __webpack_public_path__ + "assets/images/4955541b9fd52a6d6d32612c827deae1.webp";